export default __webpack_public_path__ + "static/media/bg-br.7cc2ed1f.png";